import React from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { notEmptyRule } from './validationUtils';
import ImageDisplayField from '../ImageDisplayField';
import SimpleEditor from '../../../../../../components/RichTextEditor/SimpleEditor';

const { TextArea } = Input;

const GiftCardSection = ({ 
  sectionKey, 
  sectionData, 
  uploadingImage, 
  uploadProps, 
  handleImageUploadForSection,
  currentLanguage,
  form,
  pageSlug
}) => {
  const { t } = useTranslation();
  
  // Create dynamic field names based on current language
  const langKey = currentLanguage.toLowerCase();
  const getFieldName = (field) => ['content', langKey, sectionKey, field];

  return (
    <>
      {/* Hero Section */}
      {sectionKey === 'hero_section' && (
        <>
          <Form.Item
            name={getFieldName('title')}
            label={t('Title')}
            rules={[notEmptyRule(t, 'Title is required')]}
          >
            <Input placeholder={t('Enter title')} />
          </Form.Item>

          <Form.Item
            name={getFieldName('description')}
            label={t('Description')}
            rules={[notEmptyRule(t, 'Description is required')]}
          >
            {pageSlug === 'services' || pageSlug === 'gift-card' ? (
              <SimpleEditor rows={3} placeholder={t('Enter description')} />
            ) : (
              <TextArea rows={3} placeholder={t('Enter description')} />
            )}
          </Form.Item>

          <Form.Item
            name={getFieldName('button')}
            label={t('Button Text')}
            rules={[notEmptyRule(t, 'Button text is required')]}
          >
            <Input placeholder={t('Enter button text')} />
          </Form.Item>

          <Form.Item
            name={getFieldName('image')}
            label={t('Hero Image')}
            rules={[notEmptyRule(t, 'Image is required')]}
          >
            <ImageDisplayField
              name={getFieldName('image')}
              label={t('Hero Image')}
              uploadingImage={uploadingImage}
              uploadProps={uploadProps}
              onUpload={(file) => handleImageUploadForSection(file, sectionKey)}
              onRemove={() => {
                const currentValues = form.getFieldsValue();
                const fieldPath = getFieldName('image');
                let current = currentValues;
                for (let i = 0; i < fieldPath.length - 1; i++) {
                  if (!current[fieldPath[i]]) {
                    current[fieldPath[i]] = {};
                  }
                  current = current[fieldPath[i]];
                }
                current[fieldPath[fieldPath.length - 1]] = '';
                form.setFieldsValue(currentValues);
              }}
            />
          </Form.Item>
        </>
      )}

      {/* Information Section */}
      {sectionKey === 'information_section' && (
        <>
          <Form.Item
            name={getFieldName('name')}
            label={t('Nome')}
            rules={[notEmptyRule(t, 'Il campo non può essere vuoto')]}
          >
            <Input placeholder={t('Inserisci il nome')} />
          </Form.Item>

          <Form.Item
            name={getFieldName('title')}
            label={t('Title')}
            rules={[notEmptyRule(t, 'Title is required')]}
          >
            <Input placeholder={t('Enter title')} />
          </Form.Item>

          <Form.Item
            name={getFieldName('description')}
            label={t('Description')}
            rules={[notEmptyRule(t, 'Description is required')]}
          >
            {pageSlug === 'services' || pageSlug === 'gift-card' ? (
              <SimpleEditor rows={3} placeholder={t('Enter description')} />
            ) : (
              <TextArea rows={3} placeholder={t('Enter description')} />
            )}
          </Form.Item>

          <Form.Item
            name={getFieldName('button')}
            label={t('Button Text')}
            rules={[notEmptyRule(t, 'Button text is required')]}
          >
            <Input placeholder={t('Enter button text')} />
          </Form.Item>

          <Form.Item
            name={getFieldName('image')}
            label={t('Information Image')}
            rules={[notEmptyRule(t, 'Image is required')]}
          >
            <ImageDisplayField
              name={getFieldName('image')}
              label={t('Information Image')}
              uploadingImage={uploadingImage}
              uploadProps={uploadProps}
              onUpload={(file) => handleImageUploadForSection(file, sectionKey)}
              onRemove={() => {
                const currentValues = form.getFieldsValue();
                const fieldPath = getFieldName('image');
                let current = currentValues;
                for (let i = 0; i < fieldPath.length - 1; i++) {
                  if (!current[fieldPath[i]]) {
                    current[fieldPath[i]] = {};
                  }
                  current = current[fieldPath[i]];
                }
                current[fieldPath[fieldPath.length - 1]] = '';
                form.setFieldsValue(currentValues);
              }}
            />
          </Form.Item>
        </>
      )}

      {/* Gift Card Section */}
      {sectionKey === 'gift_card_section' && (
        <>
          <Form.Item
            name={getFieldName('title')}
            label={t('Title')}
            rules={[notEmptyRule(t, 'Title is required')]}
          >
            <Input placeholder={t('Enter title')} />
          </Form.Item>

          <Form.Item
            name={getFieldName('description')}
            label={t('Description')}
            rules={[notEmptyRule(t, 'Description is required')]}
          >
            {pageSlug === 'services' || pageSlug === 'gift-card' ? (
              <SimpleEditor rows={3} placeholder={t('Enter description')} />
            ) : (
              <TextArea rows={3} placeholder={t('Enter description')} />
            )}
          </Form.Item>

          <Form.Item
            name={getFieldName('button')}
            label={t('Button Text')}
            rules={[notEmptyRule(t, 'Button text is required')]}
          >
            <Input placeholder={t('Enter button text')} />
          </Form.Item>

          <Form.Item
            name={getFieldName('image')}
            label={t('Gift Card Image')}
            rules={[notEmptyRule(t, 'Image is required')]}
          >
            <ImageDisplayField
              name={getFieldName('image')}
              label={t('Gift Card Image')}
              uploadingImage={uploadingImage}
              uploadProps={uploadProps}
              onUpload={(file) => handleImageUploadForSection(file, sectionKey)}
              onRemove={() => {
                const currentValues = form.getFieldsValue();
                const fieldPath = getFieldName('image');
                let current = currentValues;
                for (let i = 0; i < fieldPath.length - 1; i++) {
                  if (!current[fieldPath[i]]) {
                    current[fieldPath[i]] = {};
                  }
                  current = current[fieldPath[i]];
                }
                current[fieldPath[fieldPath.length - 1]] = '';
                form.setFieldsValue(currentValues);
              }}
            />
          </Form.Item>
        </>
      )}
    </>
  );
};

export default GiftCardSection;